export default function () {
  return {
    namespaced: true,
    state: {
      modalOptions: undefined,
      dialog: false,
    },
    actions: {
      open (context, options) {
        context.commit('setOptions', options.bind)
        context.commit('setDialog', options.dialog)
      },
      close (context) {
        context.commit('setDialog', false)
      },
    },
    mutations: {
      setOptions (state, options) {
        state.modalOptions = options
      },
      setDialog (state, dialog) {
        state.dialog = dialog
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modal.js